/* Code generated with AutoHTML Plugin for Figma */
import { CSSProperties, forwardRef, ReactNode } from 'react'
import { Link as RouterLink } from 'react-router'
import { _size, _style, _typeBtn } from '../../core/core'
import '../button/button.css'

export interface LinkProps {
  link: string
  size?: _size
  style?: _style
  type?: _typeBtn
  icon_left?: ReactNode
  icon_right?: ReactNode
  blank?: boolean
  width?: string | number
  isMobileWidth?: boolean
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
  className?: string
  is_download?: boolean
  is_block?: boolean
  children?: ReactNode
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({
    size = _size.S,
    style = _style.primary,
    type = _typeBtn.default,
    icon_left,
    icon_right,
    blank = false,
    link,
    width,
    isMobileWidth = false,
    onClick,
    className,
    is_download = false,
    is_block = false,
    children,
    ...props
  }, ref
  ) => {
    const variantsStyle = (): CSSProperties => {
      if (width) {
        return { width: width }
      } else {
        return {}
      }
    }

    const variantsClassName = (): string => {
      if (className) {
        return className
      }
      if (type === _typeBtn.split) {
        return `button button-${size}  button-width-${isMobileWidth} button-${style} split `

      } else {

        return `button button-${size}  button-width-${isMobileWidth} button-${style}`
      }

    }

    return (
      <RouterLink
        ref={ref}
        to={link}
        target={blank ? '_blank' : '_self'}
        download={is_download}
        style={variantsStyle()}
        onClick={onClick}
        className={variantsClassName()}
        {...props}
      >
        {icon_left}
        {is_block && <>{children}</>}
        {children && !is_block && (
          <div className={`btn-text-${size} btn-text-${style}`}>{children} {style === _style.link && (
            <div className="button-link-line"></div>
          )}</div>
        )}
        {icon_right}
      </RouterLink>
    )
  })


